import { combineReducers } from "redux";
import viewPropertyDetailsReducer from "./viewPropertyDetailsReducer";

const vwPropertyDetailsReducer = combineReducers({
    viewPropertyDetails: viewPropertyDetailsReducer

});

export default vwPropertyDetailsReducer;